import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getEquipmentData } from "./equipmentAPI";

const initialState = {}


export const fetchEquipmentData = createAsyncThunk(
    'ui/fetchEquipmentData',
    async (obj, thunkAPI) => {
      const { getState } = thunkAPI;
      const response = await getEquipmentData();
      return response.data;
    }
);

const equipmentDataSlice = createSlice({
    name: 'equipment',
    initialState,
    reducers: {
      setInverterData: (state, action) => {
     
        //state.inverter = action.payload?.inverter;
      }
    },
    extraReducers: (builder) => {
        builder
          .addCase(fetchEquipmentData.pending, (state) => {
            return {
              ...state,
              status: "loading",
              equipmentDataLoaded: false,
              eqipmentDataFetchFailed: false,
              equipmentData: initialState
            }
          })
          .addCase(fetchEquipmentData.fulfilled, (state, action) => {
            return {
              ...state,
              status: "idle",
              equipmentData: action.payload,
              eqipmentDataFetchFailed: false,
              equipmentDataLoaded: true
            }
          })
          .addCase(fetchEquipmentData.rejected, (state) => {
            return {
              ...state,
              eqipmentDataFetchFailed: true,
              status: "idle",
              equipmentDataLoaded: true,
            }
          })
        },
});

export const {
setInverterData
} =
equipmentDataSlice.actions;

export const getEquipmentMfrs = (state) => state.equipment?.equipmentData;

export default equipmentDataSlice.reducer;
